import { createContext, useContext, useMemo } from "react";

import Service from "../api/service";

const GenerateContentContext = createContext(null);

export const useGenerateContentContext = () => {
  const v = useContext(GenerateContentContext);
  if (!v) {
    throw new Error(
      "useGenerateContentContext must be used inside GenerateContentProvider",
    );
  }
  return v;
};

// Every generator endpoint follows the same contract: POST a payload, return
// the innermost data (`response.data.data`) or null.
const postGenerator = async (path, data) => {
  const response = await Service.post(path, data);
  return response?.data?.data ?? null;
};

export const GenerateContentProvider = ({ children }) => {
  const generateContent = ({ data }) =>
    postGenerator("/api/v1/content-generator", data);

  const generateImage = ({ data }) =>
    postGenerator("/api/v1/image-generator", data);

  const generateFullContentData = ({ data }) =>
    postGenerator("/api/v1/ai-data-generator", data);

  const value = useMemo(
    () => ({ generateContent, generateImage, generateFullContentData }),
    [],
  );

  return (
    <GenerateContentContext.Provider value={value}>
      {children}
    </GenerateContentContext.Provider>
  );
};
